import { Navigate, useParams } from 'react-router';
import { RedirectPageProps } from './RedirectPage.types';

function RedirectPage({ getPath }: RedirectPageProps) {
  const params = useParams();

  return <Navigate to={getPath(params)} replace />;
}

export default RedirectPage;
